import {
    Box,
    Container,
    Divider,
    Grid,
    Link,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Typography
} from '@mui/material'
import { alpha } from '@mui/material/styles'
import { Link as RouterLink } from 'react-router-dom'
import NGLogo from '@/features/themedLogos/NGLogo'
import MinusIcon from '@/icons/Minus'

const sections = [
    // {
    //     title: 'Menu',
    //     links: [
    //         {
    //             title: 'Browse Components',
    //             href: '/browse'
    //         },
    //         {
    //             title: 'Documentation',
    //             href: '/docs'
    //         }
    //     ]
    // },
    // {
    //     title: 'Placeholders',
    //     links: [
    //         {
    //             title: 'Terms & Conditions',
    //             href: '#'
    //         },
    //         {
    //             title: 'Local Authorities',
    //             href: '/local-authorities'
    //         },
    //         {
    //             title: 'Contact',
    //             href: '/contact'
    //         },
    //         {
    //             title: 'Corporate',
    //             href: '/corporate'
    //         }
    //     ]
    // },
    // {
    //     title: 'Social',
    //     links: [
    //         {
    //             title: 'Instagram',
    //             href: '#'
    //         },
    //         {
    //             title: 'Reddit',
    //             href: 'https://www.reddit.com/r/Power/'
    //         }
    //     ]
    // }
]

const Footer = (props) => (
    <Box
        sx={{
            backgroundColor: 'background.default',
            pb: 6,
            pt: {
                md: 15,
                xs: 6
            }
        }}
        {...props}
    >
        <Container maxWidth="lg">
            <Grid container spacing={3}>
                {sections.map((section, index) => (
                    <Grid
                        key={section.title}
                        sx={{
                            order: {
                                md: index + 2,
                                xs: index + 1
                            }
                        }}
                        size={{
                            md: 4,
                            sm: 4,
                            xs: 12
                        }}
                    >
                        <Typography color="textSecondary" variant="overline">
                            {section.title}
                        </Typography>
                        <List disablePadding>
                            {section.links.map((link) => (
                                <ListItem
                                    disableGutters
                                    key={link.title}
                                    sx={{
                                        pb: 0,
                                        pt: 1
                                    }}
                                >
                                    <ListItemAvatar
                                        sx={{
                                            alignItems: 'center',
                                            display: 'flex',
                                            minWidth: 0,
                                            mr: 0.5
                                        }}
                                    >
                                        <MinusIcon color="primary" />
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={
                                            <Link
                                                component={RouterLink}
                                                to={link.href}
                                                color="textPrimary"
                                                variant="subtitle2"
                                            >
                                                {link.title}
                                            </Link>
                                        }
                                    />
                                </ListItem>
                            ))}
                        </List>
                    </Grid>
                ))}
            </Grid>
            <Divider
                sx={{
                    borderColor: (theme) =>
                        alpha(theme.palette.primary.contrastText, 0.12),
                    my: 6
                }}
            />
            {/*<Grid container spacing={3}>*/}
            {/*    <Grid*/}
            {/*        sx={{*/}
            {/*            display: 'flex',*/}
            {/*            flexDirection: 'column',*/}
            {/*            order: {*/}
            {/*                md: 1,*/}
            {/*                xs: 4*/}
            {/*            }*/}
            {/*        }}*/}
            {/*    >*/}
            {/*        <NGLogo />*/}
            {/*        <Typography*/}
            {/*            color="textSecondary"*/}
            {/*            sx={{ mt: 1 }}*/}
            {/*            variant="caption"*/}
            {/*        >*/}
            {/*            © {new Date().getFullYear()} Power*/}
            {/*        </Typography>*/}
            {/*    </Grid>*/}
            {/*</Grid>*/}
        </Container>
    </Box>
)
export default Footer
